<template>
  <div class="flexRow">
    <!--     <h1 :class="firebaseAuthInitialized ? 'title' : 'loadingMessage'">
      {{ header }}
    </h1> -->
    <div class="logo">
      <img src="/icons/block-logo-bw-256.png" />
    </div>
    <button v-if="firebaseAuthInitialized" @click="login">
      Login
    </button>
  </div>
</template>

<script>
import UserProfileLink from "../components/UserProfileLink.vue";

import auth from "../auth.js";
import eventHub from "../eventHub.js";

export default {
  name: "login-view",
  components: {
    "user-profile-link": UserProfileLink,
  },
  data() {
    return {
      firebaseAuthInitialized: auth.isInitialized(),
    };
  },
  beforeCreate() {
    let self = this;
    // We're doing things this way because the methods of the component have not been created by the time this fires (we think...)
    // TODO/FIXME - Make sure this doesn't end up being a race condition where we can have an authenticated user that gets burned by this
    eventHub.$on("user-logged-in", () => {
      self.$router.push(self.redirect);
    });
    eventHub.$on("user-logged-out", () => {
      Vue.set(self, "firebaseAuthInitialized", true);
    });
  },
  methods: {
    login() {
      auth.signIn();
    },
  },
  computed: {
    redirect() {
      return this.$route.query.redirect || "/";
    },
    header() {
      return "";
      // return this.firebaseAuthInitialized ? "Block" : "Loading...";
    },
  },
};
</script>

<style scoped>
.flexRow {
  height: 85vh;
  flex-direction: column;
  justify-content: center;
}

.loadingMessage,
.title {
  margin: 4rem auto 0;
}

.title {
  font-size: 3rem;
}

button {
  font-size: 1.5rem;
  padding: 1rem 2rem;
  margin: 0rem;
  background-color: #3498db;
  color: white;
  border: none;
}

.logo {
  margin: 1rem;
}

.logo img {
  width: 196px;
  height: 196px;
}
</style>



// WEBPACK FOOTER //
// LoginView.vue?8820adea